import { create } from 'zustand';
import type { FleetVisibility } from '../types/ui/fleetVisibility';

interface FleetVisibilityState {
  visibility: FleetVisibility;
  setVisibility: (visibility: FleetVisibility) => void;
}

export const useFleetVisibilityStore = create<FleetVisibilityState>((set) => ({
  visibility: 'mine',
  setVisibility: (visibility) => set({ visibility })
}));
